import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { ADDITIONAL_SECTIONS_LINK, ADDITONAL_PREDEFINE_SECTIONS, DELETE_CONFIRMATION_BOX_CONTENT, QUICK_EDITOR, FINAL_RESUME, NEXT_SUMMARY_LABEL, POPUP_TYPES, SKILLS_LINK, SUMMARY_LINK, SUMMARY_TIPS_LINK, } from '../constants/constants';
import CustomSection from './CustomSection';
import Affiliations from './Affiliations';
import Accomplishments from './Accomplishments';
import Certifications from './Certifications';
import Volunteer from './Volunteer';
import Languages from './Languages';
import References from './References';
import Interests from './Interests';
import Softwares from './Softwares';
import QuickTips from './common/QuickTips';
import DeleteIcon from '../assets/images-new/icons/bin-icon.svg';
import CustomIcon from '../assets/images-new/icons/custom.svg';
import AccomplishmentIcon from '../assets/images-new/icons/accomplishments.svg';
import AffiliationIcon from '../assets/images-new/icons/affiliations.svg';
import CertificateIcon from '../assets/images-new/icons/certificates.svg';
import InterestIcon from '../assets/images-new/icons/interest.svg';
import LanguageIcon from '../assets/images-new/icons/languages.svg';
import ReferenceIcon from '../assets/images-new/icons/references.svg';
import SoftwareIcon from '../assets/images-new/icons/software.svg';
import VolunteerIcon from '../assets/images-new/icons/volunteers.svg';
import { useResume } from '../context/ResumeContext';
import { usePopup } from '../context/PopupContext';
import { scroll2Id, setBodyHeight, ucfirst } from '../helper';
import AdditionalSectionsName from './AdditionalSectionsName';
import { removeBodyScroll } from '../helper';

const AdditionalSections = (props) => {

  const {
    resume,
    handlers: {
      updateResumePreview,
      nuteralizeNextClick,
      nuteralizeBackClick,
      deleteSection,
    },
    next_clicked,
    back_clicked,
  } = useResume();
  const confirmbox = usePopup();
  const [accordState, setAccordState] = useState({ active: {}, unlocked: [], });
  const [showToolTip, setShowToolTip] = useState(false);
  const APRR = Object.keys(resume)
  const APS = ADDITONAL_PREDEFINE_SECTIONS
  const APSKEYS = Object.keys(APS)
  const section_list = APSKEYS.map((k) => ({ identifier: k, name: APS[k].name }))
  const section_key = 'additional_sections';
  //Flag is Do Next redirect
  const [redirectNext, setredirectNext] = useState(false)
  //Flag is Do Back redirect
  const [redirectBack, setredirectBack] = useState(false)
  //Component asked to redirect, first validate
  const [callOnce, setcallOnce] = useState(false)
  const[editSectionName, setEditSectionName] = useState('');
  const QEM = resume.enabled_tabs.includes('completed')
  const rURL = (u) => QEM ? FINAL_RESUME : u
  const nextClicked = () => {
    if (next_clicked) {//Set for next page
      if(QEM) nuteralizeNextClick({ next_label: 'Continue',}, true)
      //this condtion is specfic to first time resume will complete
      else {
        
        nuteralizeNextClick({ next_label: 'Continue'}, true, 'summary')
      }
      // nuteralizeNextClick({ next_label: 'Continue' }, true)
      return true
    } else {//Set for own page
      // if (next_clicked || next_label != 'Next') {
      //Always run for next click and self label not matched
      nuteralizeNextClick({ next_label: 'Complete'})
      return false
      //}
    }
  }
  const backClicked = () => {
    if (back_clicked) {
      nuteralizeBackClick({ next_label: NEXT_SUMMARY_LABEL })
      return true
    }
  }
  const addSections = (type => {
    if (type == 'additional_information') {//add own sections
      //unique
      const secid = 'custom_' + Math.floor(Math.random() * 1000)
      const secname = 'Custom Section'
      updateResumePreview({
        additional_sections: { custom: [secid, ...resume.additional_sections.custom] },
        [secid]: { name: secname.trim(), ...APS.additional_information.struct }
      });
      
      //Open tab
      setAccordState({ ...accordState, active: { ...accordState.active, [secid]: true } });
      scroll2Id(`${secid}_tab`, 500)

    } else if (!Object.keys(resume).includes(type)) {//Only one section allowed
      updateResumePreview({ [type]: { name: APS[type].name,  ...APS[type].struct } });
      //Open tab
      setAccordState({ ...accordState, active: { ...accordState.active, [type]: true } });
      scroll2Id(`${type}_tab`, 500)

    }
    //TODO: chagne to nice popup
    else {
      removeBodyScroll(true);
      setAccordState({ ...accordState, active: { ...accordState.active, [type]: true } });
      confirmbox.show('msgbox1',null,() => scroll2Id(`${type}_tab`, 0));
    }
  })

  const inResume = () => (
    [...APSKEYS.filter(v => (APRR.includes(v))),
    ...resume.additional_sections.custom.filter(v => APRR.includes(v))
    ]);

  const tabClicked = (t, e) => {
    const targetField = e.target.getAttribute('data-rb-field');
    switch(targetField){
      //enable name edit
      case 'edit':
        setEditSectionName(t);
        break;
      case 'input':
        //do nothing..
        break;
      default:
        //disable name edit and simply toggle the tab
        setEditSectionName('');
        if (accordState.unlocked.includes(t)) {
          //Only enabled tabs
          setAccordState({ ...accordState, active: { ...accordState.active, [t]: !accordState.active[t] } })
        }
        break;
    }
  }

  const deleteAction = (id, sec = 'regular') => {
    removeBodyScroll(true);
    if (sec == 'custom') {
      let haystack = resume.additional_sections.custom.slice()
      const needle = haystack.indexOf(id);
      (needle > -1) && haystack.splice(needle, 1)
      updateResumePreview({ additional_sections: { custom: [...haystack] } })
    }
    deleteSection(id)
    //In case of delete remove it for state to hide state, before redering start
    initAccordianState(id)
  }
  const initAccordianState = (exclude = '') => {
    const active = {}
    //Preserve the existing state of accordion
    inResume().forEach(v => active[v] = accordState.active[v] ?? false)
    setAccordState({ unlocked: inResume().filter(v => v != exclude), active: { ...active } })
  }
  useEffect(() => {
    //Only on add/delete/init action
    (inResume().length == accordState.unlocked.length) || initAccordianState()
  }, [resume]);
  useEffect(() => {
    if (nextClicked()) setredirectNext(true)
    else setredirectNext(false)
    if (backClicked()) setredirectBack(true)
    else setredirectBack(false)

    setcallOnce(false)
  }, [callOnce, resume?.heading?.fname]);
  useEffect(() => {
    removeBodyScroll(false);
    confirmbox.configurePopup(POPUP_TYPES);
  }, []);
  // nextClicked() 

  //Keep the control on multiple rendering and out of limit. Force to update once
  if ((next_clicked || back_clicked) && !callOnce) setcallOnce(true);

 
  const getIcons = (key) => {
    switch (key) {
      case 0:
        return <CustomIcon />;
        break;
      case 1:
        return <AccomplishmentIcon />;
        break;
      case 2:
        return <AffiliationIcon />;
        break;
      case 3:
        return <VolunteerIcon />;
        break;
      case 4:
        return <CertificateIcon />;
        break;
      case 5:
        return <LanguageIcon />;
        break;
      case 6:
        return <ReferenceIcon />;
        break;
      case 7:
        return <InterestIcon />;
        break;
      case 8:
        return <SoftwareIcon />;
        break;
      default:
        return <CustomIcon />;
    }
  }
  
  const showTabOpenCloseIcon = () => (
    props.hasOwnProperty('tabOpened') ?
      <span className="open-close-btn orange" onClick={() => 
      {props.tabClicked();
        setBodyHeight();
      }}>
        {props.tabOpened ? <i className="icon-arrow-up-light"></i> : <i className="icon-arrow-down-light"></i>}
      </span> : ''
  )

  if (redirectNext) { history.pushState(null, ADDITIONAL_SECTIONS_LINK); return <Redirect to={rURL(SUMMARY_LINK)} /> }
  if (redirectBack) return <Redirect to={rURL(SKILLS_LINK)} />
 
  return (<>
    <div className="editor-block-inner">
      {props.splash}
      <div className="editor-area orange-line">
        <div className="form-heading">
          {/* <div className="on-off-btn orange"><span><i></i></span></div> */}
          <div className="heading" onClick={() => (props.hasOwnProperty('tabOpened') ? props.tabClicked():'')}>
            <h1> Add More Sections</h1>
            {/* <p>Add relevant professional key skills and proficiencies.</p> */}
          </div>
          {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="quick-tips orange">
            <span
              onClick={() => {
                setShowToolTip(!showToolTip);
              }}><i className="icon-lightbulb-on"></i>Quick Tips</span>
            {showToolTip ? <QuickTips section="additional_sections" setShowToolTip={(showToolTip) => { setShowToolTip(showToolTip) }} /> : ''}
          </div>}
          {showTabOpenCloseIcon()}
        </div>
        {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="additional-blocks">
          <div className="additional-wrap">
            {section_list.map((v, k) => {
              return <div className="extra-block" key={k} onClick={e => {
                addSections(v.identifier)
              }}>
                <div className="block-icon" onClick={(e) => {tabClicked(v.identifier, e)}}>{getIcons(k)}</div>
                <div className="block-name" onClick={(e) => {tabClicked(v.identifier, e)}}>{v.name}</div>
              </div>
            })
            }
          </div>

          {resume?.additional_sections.custom?.map(cust => (
            <div className="custom-block additional-forms border" key={cust}  id={`${cust}_tab`}>
              <div className="custom-header" onClick={(e) => tabClicked(cust, e)}>
                {/* <div className="rearrange"><DraggableIcon /></div> */}
                <div className="title">
                  <span className='icon-under-section'><CustomIcon /></span>
                  {/* <h2 className="custom-title">{resume?.[cust].name ? resume?.[cust].name : '(Custom Section)'}</h2> */}
                  <AdditionalSectionsName 
                    active={accordState.active[cust]}
                    editEnabled={editSectionName == cust}
                    editDisabled={() => setEditSectionName('')}
                    type={cust}
                  />
                </div>
                <div className="delete-wrap">
                  <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteAction(cust, 'custom')), removeBodyScroll(true)}}>
                    <DeleteIcon />
                  </span>
                </div>
              </div>
              <CustomSection sec={cust} />
            </div>
          ))}
          {accordState.unlocked?.includes('accomplishments') && 
          <div className="custom-block additional-forms border" id="accomplishments_tab">
            <div className="custom-header" onClick={(e) => tabClicked('accomplishments', e)}>
              {/* <div className="rearrange"><DraggableIcon /></div> */}
              <div className="title">
                <span className='icon-under-section accom'><AccomplishmentIcon /></span>
                {/* <h2 className="custom-title">Accomplishments</h2> */}
                <AdditionalSectionsName 
                  active={accordState.active['accomplishments']}
                  editEnabled={editSectionName == 'accomplishments'}
                  editDisabled={() => setEditSectionName('')}
                  type="accomplishments"
                />
              </div>
              <div className="delete-wrap">
                <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteAction('accomplishments')), removeBodyScroll(true)}}>
                  <DeleteIcon />
                </span>
              </div>
            </div>
            <Accomplishments />
          </div>
          }
          {accordState.unlocked?.includes('affiliations') && <div className="custom-block additional-forms border" id="affiliations_tab">
            <div className="custom-header" onClick={(e) => tabClicked('affiliations', e)}>
              {/* <div className="rearrange"><DraggableIcon /></div> */}
              <div className="title">
                <span className='icon-under-section'><AffiliationIcon /></span>
                <AdditionalSectionsName 
                  active={accordState.active['affiliations']}
                  editEnabled={editSectionName == 'affiliations'}
                  editDisabled={() => setEditSectionName('')}
                  type="affiliations"
                />
              </div>
              <div className="delete-wrap">
                <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteAction('affiliations')), removeBodyScroll(true)}}>
                  <DeleteIcon />
                </span>
              </div>
            </div>

            <Affiliations />
          </div>}
          {accordState.unlocked?.includes('volunteer') && <div className="custom-block additional-forms border" id="volunteer_tab">
            <div className="custom-header" onClick={(e) => tabClicked('volunteer', e)}>
              {/* <div className="rearrange"><DraggableIcon /></div> */}
              <div className="title">
                <span className='icon-under-section'><VolunteerIcon /></span>
                {/* <h2 className="custom-title">Volunteer</h2> */}
                <AdditionalSectionsName 
                  active={accordState.active['volunteer']}
                  editEnabled={editSectionName == 'volunteer'}
                  editDisabled={() => setEditSectionName('')}
                  type="volunteer"
                />
              </div>
              <div className="delete-wrap">
                <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteAction('volunteer')), removeBodyScroll(true)}}>
                  <DeleteIcon />
                </span>
              </div>
            </div>
            <Volunteer />
          </div>}
          {accordState.unlocked?.includes('certifications') && <div className="custom-block additional-forms border"  id="certifications_tab">
            <div className="custom-header" onClick={(e) => tabClicked('certifications', e)}>
              {/* <div className="rearrange"><DraggableIcon /></div> */}
              <div className="title">
                <span className='icon-under-section'><CertificateIcon /></span>
                {/* <h2 className="custom-title">Certificate</h2> */}
                <AdditionalSectionsName 
                  active={accordState.active['certifications']}
                  editEnabled={editSectionName == 'certifications'}
                  editDisabled={() => setEditSectionName('')}
                  type="certifications"
                />
              </div>
              <div className="delete-wrap">
                <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteAction('certifications')), removeBodyScroll(true)}}>
                  <DeleteIcon />
                </span>
              </div>
            </div>
            <Certifications />
          </div>}

          {accordState.unlocked?.includes('languages') && <div className="custom-block additional-forms border"  id="languages_tab">
            <div className="custom-header" onClick={(e) => tabClicked('languages', e)}>
              {/* <div className="rearrange"><DraggableIcon /></div> */}
              <div className="title">
                <span className='icon-under-section'><LanguageIcon /></span>
                {/* <h2 className="custom-title">Languages</h2> */}
                <AdditionalSectionsName 
                  active={accordState.active['languages']}
                  editEnabled={editSectionName == 'languages'}
                  editDisabled={() => setEditSectionName('')}
                  type="languages"
                />
              </div>
              <div className="delete-wrap">
                <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteAction('languages')), removeBodyScroll(true)}}>
                  <DeleteIcon />
                </span>
              </div>
            </div>
            <Languages />
          </div>}

          {accordState.unlocked?.includes('references') && <div className="custom-block additional-forms border" id="references_tab">
            <div className="custom-header" onClick={(e) => tabClicked('references', e)}>
              {/* <div className="rearrange"><DraggableIcon /></div> */}
              <div className="title">
                <span className='icon-under-section'><ReferenceIcon /></span>
                {/* <h2 className="custom-title">References</h2> */}
                <AdditionalSectionsName 
                  active={accordState.active['references']}
                  editEnabled={editSectionName == 'references'}
                  editDisabled={() => setEditSectionName('')}
                  type="references"
                />
              </div>
              <div className="delete-wrap">
                <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteAction('references')), removeBodyScroll(true)}}>
                  <DeleteIcon />
                </span>
              </div>
            </div>
            <References />
          </div>}

          {accordState.unlocked?.includes('interests') && <div className="custom-block additional-forms border" id="interests_tab">
            <div className="custom-header" onClick={(e) => tabClicked('interests', e)}>
              {/* <div className="rearrange"><DraggableIcon /></div> */}
              <div className="title">
                <span className='icon-under-section'><InterestIcon /></span>
                {/* <h2 className="custom-title">Interests</h2> */}
                <AdditionalSectionsName 
                  active={accordState.active['interests']}
                  editEnabled={editSectionName == 'interests'}
                  editDisabled={() => setEditSectionName('')}
                  type="interests"
                />
              </div>
              <div className="delete-wrap">
                <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteAction('interests')), removeBodyScroll(true)}}>
                  <DeleteIcon />
                </span>
              </div>
            </div>
            <Interests />
          </div>}

          {accordState.unlocked?.includes('softwares') && <div className="custom-block additional-forms border"  id="softwares_tab">
            <div className="custom-header" onClick={(e) => tabClicked('softwares', e)}>
              {/* <div className="rearrange"><DraggableIcon /></div> */}
              <div className="title">
                <span className='icon-under-section'><SoftwareIcon /></span>
                {/* <h2 className="custom-title">Softwares</h2> */}
                <AdditionalSectionsName 
                  active={accordState.active['softwares']}
                  editEnabled={editSectionName == 'softwares'}
                  editDisabled={() => setEditSectionName('')}
                  type="softwares"
                />
              </div>
              <div className="delete-wrap">
                <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteAction('softwares')), removeBodyScroll(true)}}>
                  <DeleteIcon />
                </span>
              </div>
            </div>
            <Softwares />
          </div>}
        </div>}
      </div>
    </div>
  </>);
}
export default AdditionalSections;

